import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  SmartCompsetCategory,
  SmartCompsetCategoryWeight,
} from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-constant-values';
import {
  BENI_SMART_COMPSET_CATEGORY_TRANSLATIONS,
  BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS,
} from 'lumen/utils/constants/benchmark-insight/beni-smart-compset-constant-values';

export default class BeniSmartCompsetCategory extends Model {
  [Type] = 'benchmark-insight/competitors/smart-compset-category' as const;

  @attr('string') declare name: SmartCompsetCategory;
  @attr('boolean') declare suggestion: boolean;
  // @ts-expect-error: No overload matches this call.
  @attr('number', { allowNull: true })
  declare weight: SmartCompsetCategoryWeight | null;

  @service declare intl: Services['intl'];

  get formattedName(): string {
    const translation = BENI_SMART_COMPSET_CATEGORY_TRANSLATIONS[this.name];
    return this.intl.t(translation);
  }

  get formattedWeight(): string {
    if (!this.weight) {
      return '';
    }

    return this.intl.t(
      BENI_SMART_COMPSET_CATEGORY_WEIGHT_TRANSLATIONS[this.weight],
    );
  }

  get isChecked(): boolean {
    return this.weight !== null;
  }

  isSmartCompsetCategoryWeight(
    value: number,
  ): value is SmartCompsetCategoryWeight {
    return [1, 2, 3, 4, 5].includes(value);
  }
}
